import { render, staticRenderFns } from "./IndicatorsArray.vue?vue&type=template&id=6395506b&"
import script from "./IndicatorsArray.vue?vue&type=script&lang=js&"
export * from "./IndicatorsArray.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorsArray.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports